import React from 'react';



const ButtonProperty = () => {

  return (
    <div style={{display:"flex",justifyContent:"center",paddingTop:"100px"}}>
        <a href='https://formulario.yolocoliving.com.br/crm_form_kjfxt/' target="" className="btn_global_big">
            Cadastrar meu imóvel
        </a> 
         {/* <embed src="https://reservas-yolo.artaxnet.com/api/load-form/ebe" type="" width="100%" height="100%"></embed> */}
    </div>
  )
}

export default ButtonProperty